import { BaseApi } from "../shared/api";
import * as types from "./actionTypes";
import * as apiUrls from "./apiUrls";
import * as sharedTypes from "../shared/actionTypes";

export function fetchOpportunities(
    filter_hash,
    sort_params,
    page=1
  ) {
  return (dispatch) => {
    const api = new BaseApi(dispatch)
    const apiUrl = apiUrls.opportunities(page);

    return api.getRequest(
      apiUrl,
      response => {
        const opportunities = response.data.data;
        const totalPages = response.data.pagy.pages;
        const totalCount = response.data.pagy.count;

        dispatch({
          type: types.UPDATE_OPPORTUNITIES_TOTAL_PAGES,
          payload: totalPages,
        });
        dispatch({
          type: types.UPDATE_OPPORTUNITIES_CURRENT_PAGE,
          payload: page,
        });
        dispatch({
          type: types.UPDATE_OPPORTUNITIES_TOTAL_COUNT,
          payload: totalCount,
        });
        dispatch({
          type: types.OPPORTUNITIES_FETCH_SUCCESS,
          payload: opportunities,
        });
      },
      errors => {
        dispatch({
          type: sharedTypes.HANDLE_ERRORS,
          payload: {
            data: {},
            header: "Oops, something went wrong",
            body: "We are unable to show you current available opportunities.",
            duration: -1,
          }
        });
      },
      false,
      true,
      {
        filter_hash: filter_hash,
        sort_params: sort_params,
        page: page
      },
    )
  };
}

export function nextPage(page) {
  const newPage = page + 1;
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_OPPORTUNITIES_CURRENT_PAGE,
      payload: newPage,
    });

  }
}

export function previousPage(page) {
  const newPage = page - 1;
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_OPPORTUNITIES_CURRENT_PAGE,
      payload: newPage,
    });
  }
}




// WEBPACK FOOTER //
// ./src/features/projectFinder/actions.js